import React from "react";
import { useMediaQuery } from "../../../hooks/useMediaQuery";

// SVG Icons for Header Bar
const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z"
      fill="#43526E"
      fill-opacity="0.7"
    />
    <path
      d="M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z"
      fill="#43526E"
      fill-opacity="0.7"
    />
  </svg>
);

const StartsIcon = () => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.81249 17.2425H16.6845C16.8575 17.2429 17.0288 17.2091 17.1887 17.143C17.3486 17.077 17.4939 16.9799 17.6161 16.8576C17.7384 16.7352 17.8352 16.5898 17.9011 16.4299C17.967 16.2699 18.0006 16.0985 18 15.9255V7.9755L18.6135 8.29275C18.8883 8.44609 19.2124 8.48484 19.5156 8.40059C19.8188 8.31633 20.0765 8.11588 20.2327 7.84275L22.2967 4.26525C22.3867 4.13371 22.4485 3.98499 22.4781 3.82842C22.5078 3.67185 22.5048 3.51084 22.4692 3.3555C22.4322 3.19624 22.363 3.04623 22.2659 2.91468C22.1688 2.78313 22.0458 2.67281 21.9045 2.5905H21.9L18.156 0.431251C17.6654 0.148357 17.109 -0.000378916 16.5427 1.50713e-06H5.95274C5.64431 -0.000296669 5.33744 0.0436508 5.04149 0.130501C3.88787 0.536214 2.79946 1.10771 1.81049 1.827L1.71674 1.8885C1.35141 2.13286 0.979001 2.36646 0.599989 2.589C0.325362 2.74756 0.124663 3.00838 0.041748 3.31446C-0.0411669 3.62055 0.000444531 3.94701 0.157489 4.2225L2.24999 7.842C2.40325 8.11272 2.65654 8.31257 2.95548 8.39867C3.25443 8.48476 3.57521 8.45024 3.84899 8.3025L4.49999 7.9695V15.927C4.4996 16.0996 4.53325 16.2706 4.59904 16.4302C4.66482 16.5898 4.76143 16.7348 4.88335 16.857C5.00527 16.9792 5.15009 17.0762 5.30952 17.1423C5.46896 17.2085 5.63988 17.2425 5.81249 17.2425ZM16.5 15.7425H5.99999V8.2425H16.5V15.7425ZM17.241 5.9925H5.24999C5.13131 5.99262 5.01436 6.02089 4.90874 6.075L3.40874 6.846L1.60874 3.735C1.89224 3.564 2.17874 3.3765 2.47124 3.1875L2.63174 3.0825C3.50048 2.44892 4.45343 1.93976 5.46299 1.56975C5.62299 1.52325 5.78624 1.5 5.95274 1.5H6.80774C7.16774 3.624 9.03299 5.235 11.25 5.235C13.467 5.235 15.3322 3.62325 15.693 1.5H16.548C16.8502 1.5 17.148 1.57875 17.4097 1.7295L20.8785 3.73125L19.0785 6.8445L17.595 6.0765C17.4857 6.01987 17.3641 5.99102 17.241 5.9925ZM11.1255 4.48275C10.2848 4.45461 9.47772 4.1455 8.8333 3.60482C8.18888 3.06413 7.74426 2.32306 7.57049 1.5H8.35124C8.52361 2.15392 8.91187 2.73042 9.45302 3.13598C9.99417 3.54154 10.6565 3.75236 11.3325 3.73425C11.9808 3.71587 12.6058 3.48839 13.1143 3.08575C13.6228 2.6831 13.9875 2.12686 14.154 1.5H14.9295C14.747 2.36493 14.2657 3.13794 13.5701 3.68339C12.8745 4.22883 12.009 4.51184 11.1255 4.48275Z"
      fill="#43526E"
      fillOpacity="0.7"
    />
  </svg>
);

const AppearancesIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7754 9C17.7232 9.00012 18.9735 11.2593 19.4385 12.5703C19.9161 13.92 18.7893 14.9998 17.6436 15H15.4736C15.1454 15.6156 14.4626 16 13.7744 16H5.77441C5.08745 15.9999 4.40396 15.6157 4.0752 15H1.9082C0.762269 15 -0.364484 13.9202 0.112305 12.5703L0.208984 12.3135C0.740354 10.9851 2.01192 9 4.77539 9C5.65879 9.00004 6.4107 9.20982 7.04004 9.55273C7.79137 9.20674 8.69561 9.00003 9.77441 9C10.8531 9.00001 11.7566 9.20762 12.5078 9.55371C13.1377 9.21002 13.8908 9 14.7754 9ZM9.77441 11C8.77322 11 8.0521 11.2298 7.52246 11.5586L7.52344 11.5596C6.88927 11.9535 6.48025 12.5265 6.21777 13.1094C6.15565 13.248 6.10022 13.3865 6.05371 13.5234C5.9984 13.6856 5.95582 13.8462 5.91895 14H13.6299C13.609 13.9124 13.5845 13.8228 13.5576 13.7314C13.5562 13.7265 13.5542 13.7217 13.5527 13.7168C13.4415 13.3422 13.2795 12.9422 13.04 12.5703C12.7986 12.1967 12.4814 11.8514 12.0645 11.584C11.5314 11.242 10.8001 11 9.77441 11ZM4.77539 11C3.25605 11 2.49177 12.0116 2.08887 13H4.12207C4.1433 12.9339 4.16539 12.8667 4.18945 12.7988C4.19888 12.7722 4.20887 12.7456 4.21875 12.7188C4.25656 12.6161 4.29694 12.5116 4.3418 12.4062C4.38134 12.3134 4.42427 12.22 4.46973 12.126C4.4836 12.0973 4.49825 12.0688 4.5127 12.04C4.53799 11.9897 4.56371 11.9391 4.59082 11.8887C4.60892 11.855 4.62657 11.8208 4.64551 11.7871C4.68847 11.7108 4.73384 11.6346 4.78125 11.5586C4.79268 11.5402 4.80471 11.5222 4.81641 11.5039C4.84497 11.4592 4.87411 11.4145 4.9043 11.3701L4.95508 11.2939C4.97295 11.2685 4.99232 11.244 5.01074 11.2188C5.03609 11.184 5.06244 11.1497 5.08887 11.1152C5.11195 11.0851 5.13331 11.0534 5.15723 11.0234C5.03676 11.0093 4.90978 11 4.77539 11ZM14.7754 11C14.64 11 14.5119 11.0091 14.3906 11.0234C14.4148 11.0537 14.4366 11.0857 14.46 11.1162C14.4845 11.1483 14.5086 11.1806 14.5322 11.2129C14.6256 11.3406 14.7124 11.4695 14.792 11.5996C14.8316 11.6643 14.8698 11.729 14.9062 11.7939C14.9272 11.8313 14.9469 11.8689 14.9668 11.9062C14.984 11.9385 15.0011 11.9707 15.0176 12.0029C15.0432 12.0532 15.0679 12.1033 15.0918 12.1533C15.1174 12.2069 15.1423 12.2602 15.166 12.3135C15.2264 12.4494 15.2796 12.5841 15.3281 12.7158C15.3393 12.746 15.3508 12.7758 15.3613 12.8057C15.3845 12.8713 15.4063 12.9361 15.4268 13H17.4619C17.059 12.0116 16.2947 11.0001 14.7754 11ZM9.77539 0C11.3855 4.56405e-05 12.772 0.952021 13.4062 2.32324C13.5936 2.2265 13.7907 2.14828 13.9951 2.09277C14.3769 1.98915 14.7757 1.96268 15.168 2.01367C15.5602 2.06468 15.9387 2.19283 16.2812 2.39062C16.6237 2.58839 16.9238 2.85187 17.1641 3.16602C17.4044 3.48025 17.5805 3.83925 17.6816 4.22168C17.7827 4.60397 17.8074 5.00274 17.7539 5.39453C17.7003 5.78644 17.5692 6.16461 17.3691 6.50586C16.9685 7.18906 16.3135 7.68619 15.5479 7.88867C14.782 8.09109 13.9673 7.98201 13.2812 7.58594C12.9809 7.4125 12.7186 7.18799 12.498 6.92871C11.784 7.59288 10.8275 7.99997 9.77539 8C8.72676 8 7.77291 7.59578 7.05957 6.93555C6.66604 7.396 6.14137 7.73172 5.54785 7.88867C4.78202 8.09109 3.96725 7.98201 3.28125 7.58594C2.59528 7.18982 2.09329 6.53887 1.88574 5.77441C1.67829 5.01011 1.78155 4.19438 2.17285 3.50586C2.36839 3.16202 2.63074 2.85954 2.94336 2.61719C3.25595 2.37493 3.61345 2.1964 3.99512 2.09277C4.37688 1.98915 4.77569 1.96268 5.16797 2.01367C5.50935 2.05806 5.83864 2.16402 6.14453 2.32031C6.77936 0.950403 8.16624 0 9.77539 0ZM9.77539 2C8.67082 2 7.77539 2.89543 7.77539 4C7.77539 5.10457 8.67082 6 9.77539 6C10.8799 5.99994 11.7754 5.10453 11.7754 4C11.7754 2.89547 10.8799 2.00006 9.77539 2ZM4.91016 3.99707C4.77951 3.98009 4.64669 3.98897 4.51953 4.02344C4.39237 4.05796 4.27311 4.11755 4.16895 4.19824C4.06479 4.27899 3.97728 4.37959 3.91211 4.49414C3.78167 4.72358 3.74736 4.99528 3.81641 5.25C3.88559 5.50484 4.05257 5.72245 4.28125 5.85449C4.50992 5.98649 4.78185 6.02257 5.03711 5.95508C5.29214 5.88754 5.51006 5.7217 5.64355 5.49414C5.71014 5.38049 5.75459 5.25453 5.77246 5.12402C5.79028 4.99344 5.78173 4.85984 5.74805 4.73242C5.71432 4.60508 5.65522 4.48551 5.5752 4.38086C5.49512 4.27622 5.39536 4.18795 5.28125 4.12207C5.16711 4.05619 5.04084 4.01408 4.91016 3.99707ZM14.9102 3.99707C14.7795 3.98009 14.6467 3.98897 14.5195 4.02344C14.3924 4.05796 14.2731 4.11755 14.1689 4.19824C14.0648 4.27899 13.9773 4.37959 13.9121 4.49414C13.7817 4.72358 13.7474 4.99528 13.8164 5.25C13.8856 5.50484 14.0526 5.72246 14.2812 5.85449C14.5099 5.98649 14.7818 6.02257 15.0371 5.95508C15.2921 5.88754 15.5101 5.7217 15.6436 5.49414C15.7101 5.38049 15.7546 5.25453 15.7725 5.12402C15.7903 4.99344 15.7817 4.85985 15.748 4.73242C15.7143 4.60508 15.6552 4.4855 15.5752 4.38086C15.4951 4.27623 15.3954 4.18795 15.2812 4.12207C15.1671 4.05619 15.0408 4.01408 14.9102 3.99707Z"
      fill="#43526E"
      fillOpacity="0.7"
    />
  </svg>
);

const MinutesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 10C1 5.0293 5.0293 1 10 1C14.9707 1 19 5.0293 19 10C19 14.9707 14.9707 19 10 19C5.0293 19 1 14.9707 1 10Z"
      stroke="#43526E"
      stroke-opacity="0.7"
      stroke-width="2"
      stroke-linecap="square"
    />
    <path
      d="M10 5.05V10L12.7 12.7"
      stroke="#43526E"
      stroke-opacity="0.7"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);

const TouchesIcon = () => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8263 5.05214V4.50214C15.8264 4.12799 15.7426 3.75859 15.5809 3.42117C15.4193 3.08375 15.1839 2.78691 14.8923 2.55255C14.6006 2.31819 14.2601 2.15229 13.8958 2.06706C13.5315 1.98184 13.1527 1.97947 12.7873 2.06014C12.6841 1.48254 12.381 0.95965 11.9311 0.583016C11.4811 0.206382 10.9131 0 10.3263 0C9.73957 0 9.17151 0.206382 8.72159 0.583016C8.27167 0.95965 7.96856 1.48254 7.86533 2.06014C7.49998 1.97947 7.12118 1.98184 6.75687 2.06706C6.39256 2.15229 6.05202 2.31819 5.76037 2.55255C5.46872 2.78691 5.23338 3.08375 5.07173 3.42117C4.91007 3.75859 4.82621 4.12799 4.82633 4.50214V9.46414C4.559 9.23765 4.26719 9.04177 3.95633 8.88014C2.93633 8.36214 1.94633 8.44214 0.903326 8.86814C0.0633259 9.21314 -0.203674 10.1761 0.156326 10.8961L2.99833 16.5801C3.66268 17.9087 4.68382 19.0261 5.94735 19.8071C7.21088 20.5881 8.6669 21.0019 10.1523 21.0021H10.8263C12.9481 21.0021 14.9829 20.1593 16.4832 18.659C17.9835 17.1587 18.8263 15.1239 18.8263 13.0021V7.50214C18.8264 7.13138 18.744 6.76524 18.5851 6.43026C18.4262 6.09527 18.1948 5.79982 17.9077 5.5653C17.6205 5.33078 17.2848 5.16307 16.9248 5.07432C16.5648 4.98556 16.1896 4.97799 15.8263 5.05214ZM7.82633 4.50214C7.82633 4.36953 7.77365 4.24235 7.67988 4.14858C7.58611 4.05482 7.45893 4.00214 7.32633 4.00214C7.19372 4.00214 7.06654 4.05482 6.97277 4.14858C6.879 4.24235 6.82633 4.36953 6.82633 4.50214V12.0021C6.82616 12.2092 6.76175 12.411 6.64197 12.5799C6.5222 12.7488 6.35296 12.8763 6.15762 12.9449C5.96228 13.0135 5.75047 13.0197 5.55142 12.9628C5.35236 12.9059 5.17588 12.7886 5.04633 12.6271C4.12133 11.4711 3.52933 10.9071 3.05133 10.6631C2.79631 10.5244 2.49965 10.4829 2.21633 10.5461L4.78633 15.6861C5.2847 16.6826 6.05066 17.5205 6.9984 18.1062C7.94614 18.6919 9.03823 19.0021 10.1523 19.0021H10.8263C12.4176 19.0021 13.9437 18.37 15.069 17.2448C16.1942 16.1196 16.8263 14.5934 16.8263 13.0021V7.50214C16.8263 7.36953 16.7736 7.24235 16.6799 7.14858C16.5861 7.05482 16.4589 7.00214 16.3263 7.00214C16.1937 7.00214 16.0665 7.05482 15.9728 7.14858C15.879 7.24235 15.8263 7.36953 15.8263 7.50214V10.0021C15.8263 10.2674 15.721 10.5217 15.5334 10.7092C15.3459 10.8968 15.0915 11.0021 14.8263 11.0021C14.5611 11.0021 14.3068 10.8968 14.1192 10.7092C13.9317 10.5217 13.8263 10.2674 13.8263 10.0021V4.50214C13.8263 4.36953 13.7736 4.24235 13.6799 4.14858C13.5861 4.05482 13.4589 4.00214 13.3263 4.00214C13.1937 4.00214 13.0665 4.05482 12.9728 4.14858C12.879 4.24235 12.8263 4.36953 12.8263 4.50214V9.00214C12.8263 9.26735 12.721 9.52171 12.5334 9.70924C12.3459 9.89678 12.0915 10.0021 11.8263 10.0021C11.5611 10.0021 11.3068 9.89678 11.1192 9.70924C10.9317 9.52171 10.8263 9.26735 10.8263 9.00214V2.50214C10.8263 2.36953 10.7736 2.24235 10.6799 2.14858C10.5861 2.05482 10.4589 2.00214 10.3263 2.00214C10.1937 2.00214 10.0665 2.05482 9.97277 2.14858C9.879 2.24235 9.82633 2.36953 9.82633 2.50214V10.0021C9.82633 10.2674 9.72097 10.5217 9.53343 10.7092C9.3459 10.8968 9.09154 11.0021 8.82633 11.0021C8.56111 11.0021 8.30676 10.8968 8.11922 10.7092C7.93168 10.5217 7.82633 10.2674 7.82633 10.0021V4.50214Z"
      fill="#43526E"
      fillOpacity="0.7"
    />
  </svg>
);

/**
 * Helper to build image URL from logo hash or full URL
 */
const buildImageSrc = (logo) => {
  if (!logo) return null;
  const asString = String(logo);
  if (/^https?:\/\//i.test(asString)) return asString;
  return `https://images.sportdevs.com/${asString}.png`;
};

/**
 * StatsHeaderBar - Displays team info, season, starts, appearances, minutes, touches
 * Reusable for both Player and Goalkeeper stats
 */
const StatsHeaderBar = ({
  teamName = "Team",
  teamLogo = null,
  seasonName = "Season",
  starts = 0,
  appearances = 0,
  minutes = 0,
  touches = 0,
  showStartsAppearances = true,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  
  return (
    <div className={`bg-[#FFFFFF] border border-[#D6DBEA] rounded-xl p-4 ${
      isMobile 
        ? 'flex items-center gap-6 overflow-x-auto scrollbar-thin scrollbar-thumb-[#D6DBEA] scrollbar-track-transparent' 
        : 'flex items-center justify-between gap-6 flex-wrap'
    }`}>
      <div className={`flex gap-2 ${isMobile ? 'flex-shrink-0' : ''}`}>
        {/* Team Logo */}
        {teamLogo && (
          <img
            src={buildImageSrc(teamLogo)}
            alt={teamName}
            className="w-10 h-10 object-contain"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        )}

        {/* Team Name */}
        <div className="flex items-center gap-2">
          <span className="text-[#43526E] text-xl font-bold whitespace-nowrap">{teamName}</span>
        </div>
      </div>

      <div className={`flex gap-4 ${isMobile ? 'flex-shrink-0' : ''}`}>
        {/* Season */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <CalendarIcon />
          <span className="text-[#43526EB2] text-base font-bold whitespace-nowrap">
            {seasonName}
          </span>
        </div>

        {/* Starts & Appearances */}
        {showStartsAppearances && (
          <>
            <div className="flex items-center gap-2 flex-shrink-0">
              <StartsIcon />
              <span className="text-[#43526EB2] text-base font-bold whitespace-nowrap">
                {starts} <span className="font-normal"> starts </span>
              </span>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <AppearancesIcon />
              <span className="text-[#43526EB2] text-base font-bold whitespace-nowrap">
                {appearances} <span className="font-normal"> appearances </span>
              </span>
            </div>
          </>
        )}

        {/* Minutes */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <MinutesIcon />
          <span className="text-[#43526EB2] text-base font-bold whitespace-nowrap">
            {minutes} <span className="font-normal"> mins </span>
          </span>
        </div>

        {/* Touches — hidden when zero. The backend doesn't currently
            return a touches stat in the Overview block, so every player
            would otherwise show a permanent "0 touches" next to their
            real numbers, which looks broken. When touches data is wired
            up to a real source this guard quietly stops applying. */}
        {touches > 0 && (
          <div className="flex items-center gap-2 flex-shrink-0">
            <TouchesIcon />
            <span className="text-[#43526EB2] text-base font-bold whitespace-nowrap">
              {touches} <span className="font-normal"> touches </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsHeaderBar;
